import { Pipe, PipeTransform } from '@angular/core';
import { RendererType } from '../models/sections-model';

@Pipe({
  name: 'rendererTypeNormalizer',
  pure: true
})
export class RendererTypeNormalizerPipe implements PipeTransform {

  transform(rendererType: string | RendererType): string {
    console.log(`Normalizing rendererType: ${rendererType}`);
    if (typeof rendererType === 'string') {
      return this.normalizeStringValue(rendererType);
    }
    
    // Handle enum values
    switch (rendererType) {
      case RendererType.GRID:
        return 'grid';
      case RendererType.BANNER:
        return 'banner';
      case RendererType.RICH_TEXT:
        return 'rich-text';
      case RendererType.BLOGLIST:
        return 'bloglist';
      case RendererType.HEROIMAGE:
        return 'hero-image';
      case RendererType.NEWSLETTER:
        return 'news-letter-sign-up';
      case RendererType.ROW:
        return 'row';
      case RendererType.SLIDER:
        return 'slider';
      case RendererType.CART:
        return 'cart';
      case RendererType.CATEGORY:
        return 'category';
      case RendererType.PRODUCT:
        return 'product';
      case RendererType.STOREFEATURES:
        return 'store-features';
      case RendererType.TESTIMONIALS:
        return 'testimonials'
      case RendererType.BLOG:
        return 'blog';
      default:
        return 'unknown';
    }
  }
  private normalizeStringValue(value: string): string {
    // Handle "RendererType.BANNER" format
    if (value.startsWith('RendererType.')) {
      const enumValue = value.replace('RendererType.', '');
      return this.convertEnumStringToNormalized(enumValue);
    }
    
    // Handle direct string values like "banner", "BANNER", "rich-text", "rich_text"
    return value.toLowerCase().replace(/_/g, '-');
  }
  
  private convertEnumStringToNormalized(enumValue: string): string {
    switch (enumValue.toUpperCase()) {
      case "GRID":
        return 'grid';
      case "BANNER":
        return 'banner';
      case "RICH_TEXT":
        return 'rich-text';
      case "BLOGLIST":
        return 'bloglist';
      case "HEROIMAGE":
        return 'hero-image';
      case "NEWSLETTER":
        return 'news-letter-sign-up';
      case "ROW":
        return 'row';
      case "SLIDER":
        return 'slider';
      case "CART":
        return 'cart';
      case "CATEGORY":
        return 'category';
      case "PRODUCT":
        return 'product';
      case "STOREFEATURES":
        return 'store-features';
      case "TESTIMONIALS":
        return 'testimonials'
      case "BLOG":
        return 'blog';
      default:
        return enumValue.toLowerCase().replace(/_/g, '-');
    }
  }

}

/**
 * switch (this.sectionData.rendererType as RendererType | string) {
        case RendererType.BANNER:
        case "RendererType.BANNER":
        case "banner":
            this.sectionOptions = this.sectionData.bannerOptions;
            this.sectionOptionsType = "bannerOptions";             
            break;
        case RendererType.BLOGLIST:
        case "RendererType.BLOGLIST":
        case "bloglist":
            this.sectionOptions = this.sectionData.blogListOptions;
            this.sectionOptionsType = "blogListOptions";
            break;
        case RendererType.GRID:
            this.sectionOptions = this.sectionData.gridOptions;
            this.sectionOptionsType = "gridOptions";
            break;
        case RendererType.HEROIMAGE:
        case "RendererType.HEROIMAGE":
        case "hero-image":
            this.sectionOptions = this.sectionData.bannerOptions;
            this.sectionOptionsType = "bannerOptions";
            break;
        case RendererType.NEWSLETTER:
        case "RendererType.NEWSLETTER":
        case "news-letter-sign-up":
            this.sectionOptions = this.sectionData.rowOptions;
            this.sectionOptionsType = "rowOptions";
            break;
        case RendererType.RICH_TEXT:
        case "RendererType.RICH_TEXT":
        case "rich-text": 
            console.log("Getting RICH")
            this.sectionOptions = this.sectionData.richTextOptions;
            this.sectionOptionsType = "richTextOptions";
            break;
        case RendererType.ROW:
        case "RendererType.ROW":
        case "row":
        case RendererType.SLIDER:
        case "RendererType.SLIDER":
        case "slider":
        case RendererType.CART:
        case "RendererType.CART":
        case "cart":
        case RendererType.CATEGORY:
        case "RendererType.CATEGORY":
        case "category":
        case RendererType.PRODUCT:
        case "RendererType.PRODUCT":
        case "product":
        case RendererType.STOREFEATURES:
        case "RendererType.STOREFEATURES":
        case "store-features":
            this.sectionOptions = this.sectionData.rowOptions;
            this.sectionOptionsType = "rowOptions";
            break;
        case RendererType.TESTIMONIALS:
        case "RendererType.TESTIMONIALS":
        case "testimonials":
            this.sectionOptions = this.sectionData.testimonialOptions;
            this.sectionOptionsType = "testimonialOptions";
            break;
        case RendererType.BLOG:
        case "RendererType.BLOG":
        case "blog":
            this.sectionOptions = this.sectionData.blogListOptions;
            this.sectionOptionsType = "blogListOptions";
            break;
        default:
          console.log(`Got no hit for ${this.sectionData.rendererType}`)
            break;
    }
 */
